var Utils = require('./utils');
var createSprite = require('./createSprite');
var Blobs = require('./blobs');

module.exports = {
    buildRope: function(object, container, refContainer, opts)
    {
        opts = _.extend({
            repeat: 1,
            scale: {
                x: '0.03%'
            },
            position: {
                x: '0%',
                y: '0%'
            },
            rotation: 0,
            maskScale: {
                x: '100%',
                y: '100%'
            },
            maskPosition: {
                x: '0%',
                y: '0%'
            }
        }, opts);

        var sprite = createSprite(object);
        sprite.scale.y *= opts.repeat;
        sprite.tileScale.y /= opts.repeat;

        var ropeContainer = new PIXI.Sprite();
        ropeContainer.addChild(sprite);
        Utils.setSizeAndPositionFromRefSprite(ropeContainer, refContainer, {
            scale: opts.scale,
            position: opts.position
        });
        ropeContainer.rotation = opts.rotation * Math.PI / 180;

        var ropeContainerMask = new PIXI.Graphics();
        ropeContainerMask.beginFill(0xFFFFFF);
        ropeContainerMask.drawRect(0,0, 1, 1);
        ropeContainerMask.endFill();
        Utils.setSizeAndPositionFromRefSprite(ropeContainerMask, refContainer, {
            scale: opts.maskScale,
            position: opts.maskPosition
        });
        container.addChild(ropeContainer);
        container.addChild(ropeContainerMask);
        ropeContainer.mask = ropeContainerMask;

        return ropeContainer;
    },

    createFrameMaskFromSize: function(width, height)
    {
        var mask = new PIXI.Graphics();
        mask.beginFill(0xFFFFFF);
        mask.drawRect(0, 0, width, height);
        mask.endFill();
        return mask;
    },

    addBlobPainters: function(width, height, opts)
    {
        opts = _.extend({
            movieclipKeys: [],
            sprites: {},
            objectsWithTextures: {},
            minIntensity: 1,
            maxIntensity: 3,
            groupsCount: 6,
            minBlobsCount: 8,
            maxBlobsCount: 16,
            showTreadmill: true,
            showBlobs: true
        }, opts);

        var treadmillKey = 'treadmill';
        var treadmillObject = opts.objectsWithTextures[treadmillKey];
        var i;

        var group = [];

        var mask = this.createFrameMaskFromSize(width, height);

        var container = new PIXI.Container();
        container.addChild(mask);

        opts.movieclipKeys.map(_.bind(function(painterMovieclipKey){

            // treadmills
            var treadmillPainter = opts.sprites[treadmillKey] = createSprite(treadmillObject);
            Utils.setSizeAndPositionFromRefSize(treadmillPainter, width, height, treadmillObject);
            treadmillPainter.y = Utils.getValueInPixels(treadmillObject.positionsY[painterMovieclipKey]) * height;
            treadmillPainter.height = Utils.getValueInPixels(treadmillObject.scalesY[painterMovieclipKey]) * height;
            treadmillPainter.visible = opts.showTreadmill;
            var painterBlobsContainer;
            if (opts.showBlobs)
            {
                // blobs
                var painterBlobsGroup = [];
                group.push(painterBlobsGroup);
                painterBlobsContainer = opts.sprites[painterMovieclipKey+'blobs'] = Blobs.createBlobs({
                    group: painterBlobsGroup,
                    y: treadmillPainter.y + treadmillPainter.height / 3,
                    blobObject: {
                        scale: {
                            x: '3%'
                        },
                    },
                    width: width,
                    height: height,
                    groupsCount: opts.groupsCount,
                    minBlobsCount: opts.minBlobsCount,
                    maxBlobsCount: opts.maxBlobsCount,
                    objectsWithTextures: opts.objectsWithTextures
                });
                painterBlobsContainer.mask = mask;
            }

            // intensity-related movieclips
            for (i = opts.minIntensity; i <= opts.maxIntensity; i++)
            {
                var movieclipProp = painterMovieclipKey+i;
                var movieclipObject = opts.objectsWithTextures[movieclipProp];
                var painterMovieclip = opts.sprites[movieclipProp] = createSprite(movieclipObject);
                painterMovieclip.name = painterMovieclipKey;
                painterMovieclip.userData = {character: true};
                Utils.setSizeAndPositionFromRefSize(painterMovieclip, width, height, movieclipObject);
                container.addChild(painterMovieclip);
            }
            container.addChild(treadmillPainter);
            if (opts.showBlobs)
            {
                container.addChild(painterBlobsContainer);
            }

            // visual effects
            var visualEffectProp = _.get(opts.objectsWithTextures[painterMovieclipKey+'1'], 'effectSpriteKey');
            var visualEffectObject = opts.objectsWithTextures[visualEffectProp];

            if (typeof visualEffectObject !== 'undefined')
            {
                var visualEffectCount = _.get(visualEffectObject, 'count', 1);
                for (i = 0; i < visualEffectCount; i++)
                {
                    var visualEffectSprite = opts.sprites[visualEffectProp+i] = createSprite(visualEffectObject);
                    visualEffectSprite.visible = false;
                    container.addChild(visualEffectSprite);
                    visualEffectSprite.mask = mask;
                }
            }
        }, this));

        return {
            group: group,
            container: container
        };
    },

    addStamper: function(width, height, opts)
    {
        opts = _.extend({
            sprites: {},
            objectsWithTextures: {},
            minIntensity: 1,
            maxIntensity: 4,
            blobsRow: 1,
            container: null,
            groupsCount: 6,
            minBlobsCount: 8,
            maxBlobsCount: 16,
            stamperMovieclipKey: 'puppetsMaster',
            showBottomTreadmill: false
        }, opts);

        var stamperMovieclipKey = opts.stamperMovieclipKey;
        // treadmill
        var treadmillKey = 'treadmill';
        var treadmillObject = opts.objectsWithTextures[treadmillKey];
        var treadmillStamper = opts.sprites[treadmillKey] = createSprite(treadmillObject);
        Utils.setSizeAndPositionFromRefSize(treadmillStamper, width, height, treadmillObject);

        treadmillStamper.y = height * Utils.getValueInPixels(treadmillObject.positionsY[opts.stamperMovieclipKey]);
        treadmillStamper.height = height * Utils.getValueInPixels(treadmillObject.scalesY[opts.stamperMovieclipKey]);
        opts.container.addChild(treadmillStamper);

        // blobs
        var stamperBlobsGroups = opts.sprites.stampersBlobsGroups = [];
        var stamperBlobsMask = this.createFrameMaskFromSize(width, height);
        var stamperBlobsGroupsContainer = new PIXI.Container();

        var divisor = opts.blobsRow === 1 ? 2 : 4;

        for (var i = 0; i < opts.blobsRow; i++)
        {
            var stamperBlobsGroup = [];
            stamperBlobsGroups.push(stamperBlobsGroup);

            var stamperBlobsContainer = opts.sprites['stamperBlobs'+i] = Blobs.createBlobs({
                group: stamperBlobsGroup,
                y: treadmillStamper.y + treadmillStamper.height / divisor + treadmillStamper.height / 3 * i,
                blobObject: {
                    scale: {
                        x: '4%'
                    }
                },
                width: width,
                height: height,
                groupsCount: opts.groupsCount,
                minBlobsCount: opts.minBlobsCount,
                maxBlobsCount: opts.maxBlobsCount,
                stampable: true,
                objectsWithTextures: opts.objectsWithTextures
            });
            stamperBlobsGroupsContainer.addChild(stamperBlobsContainer);
        }
        stamperBlobsGroupsContainer.mask = stamperBlobsMask;
        opts.container.addChild(stamperBlobsGroupsContainer);

        if (opts.showBottomTreadmill)
        {
            var treadmillBorderBottomKey = 'treadmillBorderBottom';
            var treadmillBorderBottomObject = opts.objectsWithTextures[treadmillBorderBottomKey];
            var treadmillBorderBottom = opts.sprites[treadmillBorderBottomKey] = createSprite(treadmillBorderBottomObject);
            Utils.setSizeAndPositionFromRefSize(treadmillBorderBottom, width, height, treadmillBorderBottomObject);
            opts.container.addChild(treadmillBorderBottom);
        }

        // intensity-related movieclips
        for (i = opts.minIntensity; i <= opts.maxIntensity; i++)
        {
            var movieclipProp = stamperMovieclipKey+i;
            var movieclipObject = opts.objectsWithTextures[movieclipProp];
            var movieclip = opts.sprites[movieclipProp] = createSprite(movieclipObject);
            movieclip.userData = {character: true};
            Utils.setSizeAndPositionFromRefSize(movieclip, width, height, movieclipObject);
            opts.container.addChild(movieclip);
        }

        // ---------------------------------------------------------------------------------------

        opts.container.addChild(stamperBlobsMask);
    },

    createRefSprite: function(index, width, height, border)
    {
        var sprite = new PIXI.Graphics();
        sprite.beginFill(0,0);
        sprite.drawRect(0, 0, width, height);
        sprite.endFill();
        sprite.x = index * (width + border);

        return sprite;
    },

    createTitles: function(titleText, subtitleText, opts)
    {
        opts = _.merge({
            x: 0,
            y: 0,
            scale: 1,
            fontScale: 1,
            spaceBetween: 4,
            titleStyle: {
                fontWeight: '700',
                fontSize: '20px',
                fontFamily: 'Oswald',
                lineHeight: 20
            },
            subtitleStyle: {
                // fontWeight: 'regular',
                fontSize: '15px',
                fontFamily: 'Roboto',
                lineHeight: 15
            },
            align: 'left',
        }, opts);

        opts.titleStyle.lineHeight = opts.titleStyle.lineHeight * 2;
        opts.subtitleStyle.lineHeight = opts.subtitleStyle.lineHeight * 2;

        // console.log('text', props.scale);
        var sizeT = parseInt(opts.titleStyle.fontSize.substring(0, opts.titleStyle.fontSize.length - 2));
        opts.titleStyle.fontSize = (sizeT * 2) + 'px';

        var sizeS = parseInt(opts.subtitleStyle.fontSize.substring(0, opts.subtitleStyle.fontSize.length - 2));
        opts.subtitleStyle.fontSize = (sizeS * 2) + 'px';

        opts.titleStyle.align = opts.subtitleStyle.align = opts.align;

        var container = new PIXI.Container();
        container.scale.x = 1;
        container.scale.y = 1;

        var title = new PIXI.Text(titleText, opts.titleStyle);
        title.name = 'title';

        title.scale.x = title.scale.y = opts.fontScale * opts.scale;

        container.x = opts.x * opts.scale;
        container.y = opts.y * opts.scale;

        container.addChild(title);

        if (subtitleText)
        {
            var subtitle = new PIXI.Text(subtitleText.toUpperCase(), opts.subtitleStyle);
            subtitle.name = 'subtitle';
            subtitle.scale.x = subtitle.scale.y = opts.fontScale * opts.scale;
            subtitle.y = title.y + title.height + opts.spaceBetween * (opts.fontScale * opts.scale);
            container.addChild(subtitle);

            if (opts.align === 'right')
            {
                subtitle.x = -subtitle.width;
            }
        }

        if (opts.align === 'right')
        {
            title.x = -title.width;
        }

        return container;
    }

};



// WEBPACK FOOTER //
// ./js/lib/spritesHelper.js